import {useEffect, useRef} from "@wordpress/element";

export const useValidatePaymentExists = (
    {
        name,
        isExpress,
        errorMessage = '',
        emitResponse,
        paymentMethod,
        activePaymentMethod,
        onCheckoutValidation
    }
) => {
    const currentData = useRef({});

    useEffect(() => {
        currentData.current = {paymentMethod};
    }, [paymentMethod]);

    useEffect(() => {
        const unsubscribe = onCheckoutValidation(() => {
            if (activePaymentMethod !== name || isExpress) {
                return null;
            }
            const {paymentMethod} = currentData.current;
            if (!paymentMethod?.id) {
                return {
                    type: emitResponse.responseTypes.FAIL,
                    errorMessage,
                    context: emitResponse.noticeContexts.PAYMENTS
                }
            }
            return true;
        });
        return () => unsubscribe();
    }, [
        name,
        isExpress,
        errorMessage,
        activePaymentMethod,
        onCheckoutValidation
    ]);
}

export default useValidatePaymentExists;
